import { MembershipRead } from 'src/common/external/bambi-api/bambiApi';
import { UserTypeBadge } from 'src/common/UserTypeBadge/UserTypeBadge';

import { AssociateBadge } from './AssociateBadge';

export function UserRoleCell(membership: MembershipRead) {
  const { role } = membership;

  return !role || role === 'associate' ? (
    <AssociateBadge membership={membership} />
  ) : (
    <UserTypeBadge userType={role || 'associate'} />
  );
}
